import React from "react";
import { Provider } from "react-redux";
import { thunk } from "redux-thunk";
import reducers from "./reducers";
import { BrowserRouter } from "react-router-dom";
import { createRoot } from 'react-dom/client';
import { configureStore } from '@reduxjs/toolkit';
import { ReactKeycloakProvider, useKeycloak } from "@react-keycloak/web";
import appConfig from "./config/appConfig";
import keycloak from "./keycloak";
import "./styles/base/index.css";
import App from "./App";
import * as serviceWorker from "./serviceWorker";
// import "bootstrap/dist/css/bootstrap.min.css";
import "../node_modules/bootstrap/scss/bootstrap.scss";
import "./assets/assets/scss/main.scss";
import "./assets/assets/scss/color_skins.scss";
import "../node_modules/font-awesome/css/font-awesome.min.css";

const store = configureStore({ reducer: reducers, middleware: () => { return [thunk] } });
const root = createRoot(document.getElementById("root"));

const AppRoot = () => (
  <Provider store={store}>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </Provider>
);

const KeycloakBootstrap = () => {
  const { initialized } = useKeycloak();

  if (!initialized) {
    return null;
  }

  return <AppRoot />;
};

if (appConfig.auth.enableKeycloak) {
  const initOptions = {
    onLoad: "check-sso",
    pkceMethod: "S256",
    silentCheckSsoRedirectUri: `${window.location.origin}/silent-check-sso.html`,
    checkLoginIframe: false,
  };

  root.render(
    <ReactKeycloakProvider authClient={keycloak} initOptions={initOptions}>
      <KeycloakBootstrap />
    </ReactKeycloakProvider>
  );
} else {
  root.render(<AppRoot />);
}

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();


